import { Grid, Loader, Title } from "@mantine/core"
import moment from "moment"
import { useContext, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import AuthenticationContext from "../AuthenticationContext"
import StatsCard from "./components/StatsCard"
import Props, { Stats } from "./StatsGrid.types"

const convertToSeries = (
  stats: Stats[],
  field: "consollesCount" | "sensorsCount" | "usersCount" | "notificationCount"
) =>
  stats.map(({ date, [field]: y }) => ({
    x: +new Date(date),
    y,
  }))

const StatsGrid = ({ mobile }: Props) => {
  const { t } = useTranslation()
  const [token] = useContext(AuthenticationContext)

  const [stats, setStats] = useState<Stats[]>([])
  const [error, setError] = useState<boolean>(false)

  useEffect(() => {
    fetch(
      `https://resinglass-api.igloo.ooo/admin/stats?startDate=2023-01-01&endDate=${moment().format(
        "YYYY-MM-DD"
      )}`,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    )
      .then((response) => response.json().then((stats) => setStats(stats)))
      .catch(() => setError(true))
  }, [token])

  return error ? (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Title order={1} style={{ marginBottom: "24px" }}>
        {t`Errore`}
      </Title>
    </div>
  ) : !stats.length ? (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Loader />
    </div>
  ) : (
    <Grid style={{ margin: "16px" }}>
      <StatsCard
        mobile={mobile}
        title={t`Numero consolle`}
        series={convertToSeries(stats, "consollesCount")}
        type="consolles"
      />
      <StatsCard
        mobile={mobile}
        title={t`Numero sensori`}
        series={convertToSeries(stats, "sensorsCount")}
        type="sensors"
      />
      <StatsCard
        mobile={mobile}
        title={t`Numero utenti`}
        series={convertToSeries(stats, "usersCount")}
        type="users"
      />
      <StatsCard
        mobile={mobile}
        title={t`Numero allerte`}
        series={convertToSeries(stats, "notificationCount")}
        type="alerts"
      />
    </Grid>
  )
}

export default StatsGrid
